import errorToast from "../../../components/toast/ErrorToast";
import CreateUserFeature from "./CreateUserFeature";
import {BACKOFFICE_USER_PATH} from "../../../routes";


export default class CreateBackofficeUserFeature extends CreateUserFeature {
    createUserWithApiClient(user, responseHandler) {
        return this._application.apiClient().createBackofficeUser(user, responseHandler);
    }

    showAlert(error) {
        if (error.code === 'duplicated_user') {
            errorToast('Ya existe un usuario para este email.')
        } else if(error.code === 'invalid_user_domain') {
            errorToast('No se puede crear un usuario con ese dominio para el backoffice.')
        }
        else {
            errorToast("No se pudo crear el usuario.")
        }
    }

    userPath(){
        return BACKOFFICE_USER_PATH
    }
}